export default "__VITE_ASSET__C2JYp4oj__"